import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
// import { useTranslation } from "react-i18next";
// import { StyleSheet, View, Text, TouchableOpacity, Image, Dimensions } from "react-native";
// import customTheme from "../../../utils/ui";
import StoreStepper from "./StoreStepper";
// import useAuthentication from "../../hooks/useAuthentication";
const StoreFilters = ({ style }) => {
  const [emirateOpen, setEmirateOpen] = useState(false);
  const [regionOpen, setRegionOpen] = useState(false);
  const handleEmirateOpen = () => {
    setEmirateOpen(true);
  };
  const handleRegionOpen = () => {
    setRegionOpen(true);
  };
  return (
    <>
      <Grid container spacing={2} justifyContent={"center"}>
        <Grid
          onClick={handleEmirateOpen}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            cursor: "pointer",
            padding: 10,
            bottom: 10,
            backgroundColor: "#fac904",
            elevation: 10,
            borderRadius: 20,
            color: "white",
            display: "flex",
            justifyContent: "center",
            width: '50px !important'
          }}
        >
          Select Emirate's
        </Grid>
        <div key={"Emirate Dialog"}>
          <Dialog
            open={emirateOpen}
            onClose={() => setEmirateOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogActions>
              <StoreStepper step={0} onClose={() => setEmirateOpen(false)} />
            </DialogActions>
          </Dialog>
        </div>
        <Grid
          onClick={handleRegionOpen}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            cursor: "pointer",
            padding: 10,
            bottom: 10,
            marginTop: 15,
            backgroundColor: "#fac904",
            elevation: 10,
            borderRadius: 20,
            color: "white",
            display: "flex",
            justifyContent: "center",
            width: '50px !important'
          }}
        >
          Select Area's
        </Grid>
        <div key={"Area Dialog"}>
          <Dialog open={regionOpen} onClose={() => setRegionOpen(false)}>
            <DialogActions>
              <StoreStepper step={1} onClose={() => setRegionOpen(false)} />
            </DialogActions>
          </Dialog>
        </div>
      </Grid>
    </>
  );
};

export default StoreFilters;
